import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/macros'),
      component: () => import('../Wrapper'),
      props: params => {
        const showBackButton = params.name !== 'macros_wrapper';
        return {
          headerTitle: 'MACROS.HEADER',
          headerButtonText: 'MACROS.HEADER_BTN_TXT',
          icon: 'flash-settings',
          showBackButton,
        };
      },
      children: [
        {
          path: '',
          name: 'macros_wrapper',
          component: () => import('./Index'),
          roles: ['administrator', 'agent'],
        },
        {
          path: 'new',
          name: 'macros_new',
          component: () => import('./MacroEditor'),
          roles: ['administrator', 'agent'],
        },
        {
          path: ':macroId/edit',
          name: 'macros_edit',
          component: () => import('./MacroEditor'),
          roles: ['administrator', 'agent'],
        },
      ],
    },
  ],
};
